class CustomPerfumesCollection extends HTMLElement {
  connectedCallback() {
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    this.addEventListener('cart:update', this.handleCartUpdate);
    this.initSlider();
  }

  disconnectedCallback() {
    this.removeEventListener('cart:update', this.handleCartUpdate);
    if (this.splide) {
      this.splide.destroy(true);
      this.splide = null;
    }
  }

  handleCartUpdate(event) {
    if (event.detail?.data?.didError) return;
    if (this.dataset.cartType !== 'drawer') return;

    const header = document.querySelector('custom-header');
    if (header && typeof header.openCartDrawer === 'function') {
      header.openCartDrawer();
      return;
    }

    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.showDialog === 'function') {
      drawer.showDialog();
    } else if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  initSlider() {
    if (this.splide || typeof window.Splide === 'undefined') return;

    const slider = this.querySelector('[data-cpc-slider]');
    if (!slider) return;

    const slides = slider.querySelectorAll('.splide__slide');
    if (slides.length < 2) return;

    this.splide = new window.Splide(slider, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: '1.25rem',
      pagination: true,
      arrows: false,
      rewind: false,
      drag: true,
      speed: 450,
      mediaQuery: 'min',
      breakpoints: {
        750: {
          destroy: true,
        },
      },
    });

    this.splide.mount();
  }
}

if (!customElements.get('custom-perfumes-collection')) {
  customElements.define('custom-perfumes-collection', CustomPerfumesCollection);
}
